/**
 * @generated SignedSource<<fa3b21f822a17be26fec8cd7cec18b79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateRowFlight_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateRowFlightDetails_data">;
  readonly " $fragmentType": "PackageDateRowFlight_data";
};
export type PackageDateRowFlight_data$key = {
  readonly " $data"?: PackageDateRowFlight_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateRowFlight_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateRowFlight_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateRowFlightDetails_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "00f8efcb8698250ded4378e8a2dedd6d";

export default node;
